"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseEnum = void 0;
class BaseEnum {
    name;
    value;
    constructor(value, name) {
        this.name = name;
        this.value = value;
    }
    static findByValue = function (value) {
        return Object.values(this)
            .filter((obj) => obj instanceof BaseEnum)
            .find((obj) => {
            return obj.value === value;
        });
    };
    static findByName = function (name) {
        return Object.values(this)
            .filter((obj) => obj instanceof BaseEnum)
            .find((obj) => {
            return obj.name === name;
        });
    };
    static findEnums = function () {
        return Object.values(this).filter((obj) => obj instanceof BaseEnum);
    };
    static findEnumValues = function () {
        const list = Object.values(this).filter((obj) => obj instanceof BaseEnum);
        return list.reduce((res, item) => {
            return { ...res, [item.value]: item.name };
        }, {});
    };
}
exports.BaseEnum = BaseEnum;
//# sourceMappingURL=base-enum.js.map